//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import SegmentsCondition from "./segments-condition";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import MaterialInput from "@Shared/components/inputs/material-input";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentsEdit",
  components: {
    SegmentsCondition,
    SimpleButton,
    MaterialInput
  },
  mixins: [validationMixin],
  props: {
    segments: {
      type: Array,
      required: true
    },
    currentSegment: {
      type: Object,
      required: true
    },
    isNew: {
      type: Boolean,
      default: false
    },
    createSegmentLoading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      createSegmentLoadingLocal: this.createSegmentLoading,
      createSegmentClicked: false,
      newSegmentCreated: false
    };
  },
  computed: {
    alternateJoinValue() {
      return {
        and: "or",
        or: "and"
      };
    },
    joinText() {
      return {
        and: this.$tc("global.words.all", 1),
        or: this.$t("global.words.any")
      };
    },
    getCurrentJoinText() {
      return this.joinText[this.currentSegment.join];
    },
    getAlternateJoinText() {
      return this.joinText[this.alternateJoinValue[this.currentSegment.join]];
    },
    saveButtonText() {
      return this.isNew && !this.createSegmentClicked ? this.$t("lists.segments.createSegment") : this.$t("lists.segments.saveSegment");
    },
    isValid() {
      return !this.$v.$invalid;
    },
    canDeleteCondition() {
      return this.currentSegment.conditions.length > 1;
    }
  },
  watch: {
    async createSegmentLoading(val) {
      this.createSegmentClicked = true;
      await this.$nextTick();
      this.createSegmentClicked = false;
      this.createSegmentLoadingLocal = val;
    },
    isNew(val) {
      if (val && this.newSegmentCreated) {
        this.newSegmentCreated = false;
      }
    }
  },
  validations: {
    currentSegment: {
      conditions: {
        $each: {
          values: {
            $each: {
              value: {
                required
              }
            }
          }
        }
      },
      name: {
        required
      }
    }
  },
  methods: {
    handleAddSegment() {
      this.$emit("condition-add");
    },
    handleUpdateCondition(data, index) {
      this.$emit("condition-update", data, index);
    },
    handleDeleteCondition(index) {
      this.$emit("condition-delete", index);
    },
    handleToggleJoin() {
      const join = this.alternateJoinValue[this.currentSegment.join];
      this.$emit("toggle-join", join);
    },
    handleChangeName(val) {
      this.$emit("change-name", val);
    },
    handleSubmit() {
      if (this.isNew) this.newSegmentCreated = true;
      this.$emit("submit");
    }
  }
});